// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"c67f72ba","119":"ee0653c5","398":"6809c029","484":"1d060583","613":"34815be6","647":"9f545fa7","680":"5e565a34","702":"94c443b9","794":"76164333"}[chunkId] + ".js";
};